import React from "react";
import { CameraAlt } from "@material-ui/icons";
import LoadableButton from "src/components/LoadableButton";
import ReceiptDialog from "src/components/ReceiptDialog";

export interface ReceiptControlProps {
  /** Resolved receipt URL (remote or blob) currently shown, if any. */
  receiptUrl?: string;
  /** True when a receipt (existing or freshly selected) is attached. */
  hasReceipt: boolean;
  /** True when the attached receipt is a PDF, which previews differently. */
  receiptIsPdf?: boolean;
  /** True while the stored receipt's URL is still being fetched. */
  receiptLoading?: boolean;
  loading?: boolean;
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onConfirm: (newImageFile?: File) => void | Promise<void>;
  onDelete: () => void | Promise<void>;
}

/**
 * The "Add / View Receipt" action button plus its dialog. Receipt state
 * (selected file, resolved URL, fetching) is owned by the parent form; this
 * component is purely presentational.
 */
export function ReceiptControl({
  receiptUrl,
  hasReceipt,
  receiptIsPdf,
  receiptLoading,
  loading,
  open,
  onOpen,
  onClose,
  onConfirm,
  onDelete,
}: ReceiptControlProps) {
  return (
    <>
      <ReceiptDialog
        open={open}
        receiptFilename={receiptUrl}
        receiptIsPdf={receiptIsPdf}
        onCancel={onClose}
        onConfirm={onConfirm}
        onDelete={onDelete}
      />
      <LoadableButton
        variant="contained"
        color="primary"
        disabled={loading}
        loading={receiptLoading}
        onClick={onOpen}
        startIcon={<CameraAlt />}
        tabIndex={-1}
      >
        {hasReceipt || receiptLoading ? "View/Update Receipt" : "Add Receipt"}
      </LoadableButton>
    </>
  );
}
